'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.getCsrfHeader = getCsrfHeader;
exports.deleteSearch = deleteSearch;
exports.toQueryString = toQueryString;
exports.urlQueryJoin = urlQueryJoin;
exports.toAxiosParams = toAxiosParams;
exports.extractErrorInfo = extractErrorInfo;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * 获得添加 csrf token 到 request headers
 * @param {Object} params 用户传入的request params
 * @returns {Object} 设置好 csrf token 的 params.
 */

function getCsrfHeader(params) {
  if (!params.enableCsrf) {
    return {};
  }

  if (['POST', 'PUT', 'PATCH', 'DELETE'].indexOf(params.method.toUpperCase()) === -1) {
    return {};
  }

  var csrfTokenTmp = Object.assign({}, window.csrfToken, params.csrfToken);
  if (!csrfTokenTmp.tokenName || !csrfTokenTmp.tokenValue) {
    throw new Error('csrf token is invalid, check if csrf token includes tokenName and tokenValue');
  }
  /**
   * 对于POST or PUT方法,在请求头中加上token
   */
  return _defineProperty({}, csrfTokenTmp.tokenName, csrfTokenTmp.tokenValue);
}

/**
 * 删除 url 中的查询参数
 * @param {string} url 传入的 url
 * @returns {string} 去处查询参数之后的 url
 */
function deleteSearch(url) {
  var searchIndex = url.indexOf('?');

  if (searchIndex > -1) {
    return url.slice(0, searchIndex);
  }

  return url;
}

function buildParams(prefix, obj, traditional, add) {
  var rbracket = /\[\]$/;

  if (Array.isArray(obj)) {
    // Serialize array item.
    for (var i = 0; obj && i < obj.length; i += 1) {
      var v = obj[i];
      if (traditional || rbracket.test(prefix)) {
        // Treat each array item as a scalar.
        add(prefix, v);
      } else {
        buildParams(prefix + '[' + ((typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' ? i : '') + ']', v, traditional, add);
      }
    }
  } else if (obj && obj.toString() === '[object Object]') {
    // Serialize object item.
    for (var name in obj) {
      buildParams(prefix + '[' + name + ']', obj[name], traditional, add);
    }
  } else {
    // Serialize scalar item.
    add(prefix, obj);
  }
}

/**
 * jsonp 中需要把 data 转换成 query string
 * inspiration from：https://github.com/ded/reqwest/blob/22da21c5de609d5b75ee21eb4484bce42c474973/src/reqwest.js#L552
 */
function toQueryString(o, trad) {
  var traditional = trad || false;
  var s = [];
  var add = function add(key, value) {
    // If value is a function, invoke it and return its value
    value = typeof value === 'function' ? value() : value;
    if (value !== undefined) {
      s[s.length] = encodeURIComponent(key) + '=' + encodeURIComponent(value);
    }
  };

  // If an array was passed in, assume that it is an array of form elements.
  if (Array.isArray(o)) {
    for (var i = 0; o && i < o.length; i += 1) {
      add(o[i].name, o[i].value);
    }
  } else {
    // If traditional, encode the "old" way (the way 1.3.2 or older
    // did it), otherwise encode params recursively.
    for (var prefix in o) {
      if (Object.prototype.hasOwnProperty.call(o, prefix)) {
        buildParams(prefix, o[prefix], traditional, add);
      }
    }
  }

  // spaces should be + according to spec
  return s.join('&').replace(/%20/g, '+');
}

/**
 * 拼接有查询参数的 url
 * @param {string} url 传入的 url，可以为空
 * @param {string | object} params 传入的查询参数
 *
 * @returns {string} 拼接好的 url
 */
function urlQueryJoin(url, params) {
  var paramString = typeof params === 'string' ? params : toQueryString(params);
  if (!url) {
    return paramString;
  }
  if (!params) {
    return url;
  }
  var symbol = url.indexOf('?') !== -1 ? '&' : '?';

  return url + (paramString ? symbol + paramString : '');
}

/**
 * 兼容老的 reqwest 参数调用
 * 注意：很难保证完全兼容，尽量使用新的参数
 */

function toAxiosParams() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var axiosParams = Object.assign({}, params);

  // type ---> responseType
  if (axiosParams.type) {
    axiosParams.responseType = axiosParams.type;
    delete axiosParams.type;
  }

  // ignore contentType for request, and merge data into url
  var isIgnoreConentType = ['GET', 'OPTIONS', 'HEAD'].indexOf(params.method.toUpperCase()) !== -1;
  if (axiosParams.contentType && isIgnoreConentType) {
    delete axiosParams.contentType;
    axiosParams.url = urlQueryJoin(axiosParams.url, axiosParams.data);
    delete axiosParams.data;
  }

  // move contentType to headers
  if (axiosParams.contentType) {
    axiosParams.headers = Object.assign({}, axiosParams.headers, {
      'Content-Type': axiosParams.contentType
    });

    // encoded the data to string
    if (axiosParams.contentType.indexOf('application/x-www-form-urlencoded') !== -1 && _typeof(axiosParams.data) === 'object') {
      axiosParams.data = toQueryString(axiosParams.data);
    }
  }

  // axios would use XDomainRequest automatically, so delete the crossOrigin
  if (axiosParams.crossOrigin) {
    delete axiosParams.crossOrigin;
  }

  // disable callback style
  if (axiosParams.success || axiosParams.error || axiosParams.complete) {
    throw new Error('use promise style instead callback');
  }

  return axiosParams;
}

/**
 * 提取接口异常的相关错误信息
 * @param {Error} err - 本次请求的错误对象
 * @param {Object} params - 本次请求的配置对象
 */
var RETCODE_MAX_LENGTH = 800;
function extractErrorInfo() {
  var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = arguments[1];

  var result = '';
  var resp = err.response || {};

  try {
    var retData = {
      status: resp.status,
      msg: err.message,
      params: {
        contentType: params.contentType,
        data: params.data,
        method: params.method,
        headers: params.headers,
        type: params.type,
        url: params.url,
        csrfToken: params.csrfToken
      },
      data: resp.data
    };

    result = JSON.stringify(retData);
    if (result.length > RETCODE_MAX_LENGTH) {
      delete retData.data;
      result = JSON.stringify(retData);
    }
    if (result.length > RETCODE_MAX_LENGTH) {
      delete retData.params.data;
      result = JSON.stringify(retData);
    }
  } catch (e) {
    result = JSON.stringify({
      msg: 'extractErrorInfo() stringify error'
    });
  }

  return result;
}